<template>
  <div class="capacitor-dielectric-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>C = ε_r · ε₀ · A / d$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Capacitor Plates -->
          <rect x="100" y="60" width="10" height="120" fill="#ff4757" />
          <rect x="290" y="60" width="10" height="120" fill="#00d2ff" />
          <text x="80" y="55" fill="#ff4757" font-size="10">+</text>
          <text x="300" y="55" fill="#00d2ff" font-size="10">-</text>

          <!-- Electric Field Lines -->
          <line v-for="i in 10" :key="'l'+i" x1="110" :y1="70+i*10" x2="290" :y2="70+i*10" stroke="rgba(255,255,255,0.1)" stroke-width="1" />

          <!-- Dielectric Slab -->
          <g :transform="`translate(${slabPos}, 60)`">
             <rect width="100" height="120" :fill="isInserted ? 'rgba(0, 210, 255, 0.4)' : 'rgba(150, 150, 150, 0.2)'" stroke="#888" />
             <text x="10" y="20" fill="#fff" font-size="8">电介质 ε_r</text>
             <!-- Polarized molecules (Visual) -->
             <g v-if="isInserted" opacity="0.6">
                <circle v-for="i in 3" :key="'m'+i" :cx="i*25" cy="50" r="5" fill="#fff" />
             </g>
          </g>

          <!-- Measurement -->
          <g transform="translate(150, 210)">
             <text x="0" y="0" fill="#ffd700" font-size="12">电容量 C: {{ capacitance.toFixed(2) }} pF</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电介质极化会削弱内部电场，提高容电能力</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>插入电介质</label>
             <el-slider v-model="slabPosSlider" :min="110" :max="300" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>介电常数 ε_r: {{ epsilonR }}</label>
             <el-radio-group v-model="epsilonR" size="mini">
                <el-radio :label="1">真空/空气</el-radio>
                <el-radio :label="3">云母</el-radio>
                <el-radio :label="80">陶瓷/水</el-radio>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>在电容器两极板间插入电介质时，电介质分子在电场作用下会发生**电极化**。感应电荷在电介质表面产生，其形成的电场与原电场方向相反，从而减弱了极板间的合电场强度。对于带电量不变的电容器，这会导致电压降低，从而**提高了电容** $C$。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CapacitorDielectricViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      slabPosSlider: 300,
      epsilonR: 3
    }
  },
  computed: {
    slabPos() { return this.slabPosSlider; },
    isInserted() { return this.slabPosSlider < 290; },
    capacitance() {
       let overlap = Math.max(0, 290 - this.slabPosSlider);
       let airPart = 180 - overlap;
       // C = e0 * A / d * (airPart + eR * overlap) / 180
       return 50 * (airPart + this.epsilonR * overlap) / 180;
    }
  }
}
</script>

<style scoped lang="scss">
.capacitor-dielectric-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
